import React, { useState, useContext, Fragment } from 'react';
import { LangCtx } from '../../../../lib/context';
import DeleteConfirmModal from '../../../admin/users/components/DeleteConfirmModal';
import CreateDegree from './CreateDegree';

const DegreeCard = ({ item, handleDelete, loadData, setPage }) =>
{
    const [ delOpen, setOpenDelOpen ] = useState(false);
    const [ editOpen, setEditOpen ] = useState(false);
    // const [loading, setLoading] = useState(false);
    const { l } = useContext(LangCtx);

    const handleEditOpen = () =>
    {
        setEditOpen(true);
    };

    const handleOpen = () =>
    {
        setOpenDelOpen(true);
    };

    const handleClose = (status = false) =>
    {
        if (status === true)
        {
            setPage(0);
            loadData();
        };
        setEditOpen(false);
    };

    const handleDeleteDeg = () =>
    {
        // setLoading(true);
        // deleteDegree(item?._id).then((res) => {
        //     if(res.status){
        //         toast.success(l.deg_del, {
        //             position: toast.POSITION.TOP_RIGHT
        //         })
        //     setOpenDelOpen(false);
        //     loadData();
        //     }else{
        //         console.log('error')
        //     }
        //     setLoading(false);
        // }).catch((err) => {
        //     toast.error(err?.response?.data?.error, {
        //         position: toast.POSITION.TOP_RIGHT
        //     })
        //     setLoading(false);
        // })
        handleDelete(item?._id);
        setOpenDelOpen(false);

    };
    return (
        <Fragment key={item._id}>
                {/* {loading && <Loader/>} */}
                <div className="flexCol brdrRadiusXSM pdngMD whiteBg brdrSM fullHeight">
                    <div className='flexMinHeightCol'>
                        <div className='flexCol'>
                            <span className='elslistTxtM'>{l.degrees_name}</span>
                            <span className='vrtclAvtrTxtL'>{item?.name}</span>
                        </div>
                        <div className='flexCol  pdngTB8'>
                            <span className='elslistTxtM'>
                                {l.code}
                            </span>
                            <span className='vrtclAvtrTxtL'>{item?.code}</span>
                        </div>
                        {/* <div className='flexCol pdngTB8'>
                <span className="elslistTxtM ">Description </span>
                <span className='titleHeading headingSM lineHight mrgnTopXS'>Lorem Ipsum is simply dummy text of the  unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</span>
            </div> */}
                    </div>
                    <div className='flexRow alignCenter brdrTop justifyCenter pdngXS'>
                        <div className='pTxtFlx alignCenter justifyCenter brdrRight' onClick={handleEditOpen}>
                            <div className="actionItem ">
                                <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                            </div>
                            <span className='pointer'>{l.edit}</span>
                        </div>
                        <div className='pTxtFlx alignCenter justifyCenter ' onClick={handleOpen}>
                            <div className="actionItem pTxtFlx">
                                <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                            </div>
                            <span className='pointer'>{l.delete}</span>
                        </div>
                    </div>
                </div>
                {editOpen && <CreateDegree open={editOpen} handleClose={handleClose} deptData={item} />}
                {delOpen && <DeleteConfirmModal header="degree" openDelete={delOpen} closeDelete={() => setOpenDelOpen(false)} handleDelete={handleDeleteDeg} deptData={item} />}
         </Fragment>
    );
};

export default DegreeCard;